import { useEffect, useMemo, useState } from 'react';
import styles from '../../../assets/styles/Admin/AdminProducts.module.scss';
import defaultProductImage from '../../../assets/img/image-broken.png';
import { IoChevronBack, IoChevronForward } from 'react-icons/io5';

const SingleProductImage = ({ imageUrls, name }) => {
	const productImageUrls = useMemo(() => {
		const validImages = (imageUrls || []).filter(Boolean);
		return validImages.length > 0 ? validImages : [defaultProductImage];
	}, [imageUrls]);

	const [currentImageIndex, setCurrentImageIndex] = useState(0);
	const [showImageNav, setShowImageNav] = useState(false);

	const hasMultipleImages = productImageUrls.length > 1;
	const mainImage = productImageUrls[currentImageIndex] || defaultProductImage;

	const setMainImage = imageUrl => {
		const nextIndex = productImageUrls.indexOf(imageUrl);
		if (nextIndex >= 0) {
			setCurrentImageIndex(nextIndex);
		}
	};

	const goToNextImage = () => {
		if (!hasMultipleImages) return;
		setCurrentImageIndex(prev => (prev + 1) % productImageUrls.length);
	};

	const goToPreviousImage = () => {
		if (!hasMultipleImages) return;
		setCurrentImageIndex(
			prev => (prev - 1 + productImageUrls.length) % productImageUrls.length
		);
	};

	const handleMainImageMouseEnter = () => {
		if (hasMultipleImages) {
			setShowImageNav(true);
		}
	};

	const handleMainImageMouseLeave = () => {
		setShowImageNav(false);
	};

	useEffect(() => {
		setCurrentImageIndex(0);
		setShowImageNav(false);
	}, [productImageUrls]);
	return (
		<div className={styles.singleProduct__images}>
			<div
				className={styles.singleProduct__mainImage}
				onMouseEnter={handleMainImageMouseEnter}
				onMouseLeave={handleMainImageMouseLeave}>
				<img
					src={mainImage}
					alt={name}
					onError={e => {
						e.currentTarget.onerror = null;
						e.currentTarget.src = defaultProductImage;
					}}
				/>
				{hasMultipleImages && showImageNav && (
					<>
						<button
							type="button"
							onClick={goToPreviousImage}
							className={`${styles.singleProduct__imageArrow} ${styles.singleProduct__imageArrowLeft}`}
							aria-label="Show previous image">
							<IoChevronBack />
						</button>
						<button
							type="button"
							onClick={goToNextImage}
							className={`${styles.singleProduct__imageArrow} ${styles.singleProduct__imageArrowRight}`}
							aria-label="Show next image">
							<IoChevronForward />
						</button>
					</>
				)}
			</div>
			<div className={styles.singleProduct__otherImages}>
				{imageUrls?.map((url, index) => (
					<img
						key={index}
						src={url}
						alt={`${name} ${index + 1}`}
						className={
							url === mainImage ? styles.singleProduct__selectedImage : ''
						}
						onClick={() => setMainImage(url)}
						onError={e => {
							e.currentTarget.onerror = null;
							e.currentTarget.src = defaultProductImage;
						}}
					/>
				))}
			</div>
		</div>
	);
};

export default SingleProductImage;
